<!-- Card (grade) -->
<div class="card" *ngIf="layout === 'card'; else row">
  <div class="header">
    <div class="numero">
      <strong>Nº {{ nfce?.numero ?? "—" }}</strong>
      <small>Série {{ nfce?.serie ?? "—" }}</small>
    </div>
    <span class="status" [ngClass]="status.toLowerCase()">
      {{ nfce?.status ?? "—" }}
    </span>
  </div>

  <div class="body">
    <div class="valor">
      {{ nfce?.valor | currency: "BRL" : "symbol" : "1.2-2" : "pt-BR" }}
    </div>
    <div class="prop" *ngIf="nfce?.clienteNome">
      <small>Obra</small>
      <span [title]="nfce?.clienteNome">
        {{ nfce?.numeroObra ? "#" + nfce?.numeroObra + " · " : "" }}
        {{ nfce?.clienteNome }}
      </span>
    </div>
    <div class="prop">
      <small>Consumidor</small>
      <span *ngIf="nfce?.destinatario; else naoIdentificado">
        {{ nfce?.destinatario ?? "" | formatter: "cpfCnpj" }}
      </span>
    </div>
    <div class="prop">
      <small>Emissão</small>
      <span>{{ nfce?.emissao ?? "—" }}</span>
    </div>
    <div class="prop prazo" *ngIf="autorizada && segundosRestantes() !== null">
      <small>Cancelamento</small>
      <span [class.encerrado]="!podeCancelar">
        {{ podeCancelar ? "até " + tempoRestante() : "prazo encerrado" }}
      </span>
    </div>
    <ng-container *ngIf="rejeitada">
      <ng-container *ngTemplateOutlet="rejeicao"></ng-container>
    </ng-container>
  </div>

  <div class="footer">
    <div class="content">
      <p-menu #menu [model]="menuOptions()" [popup]="true"></p-menu>
      <app-button
        text="Opções"
        icon="pi-bars"
        (click)="menu.toggle($event)"
        backgroundColor="var(--pink-500)"
        textAlign="flex-start"
        [fullWidth]="true"
        [dense]="true"
        [disabled]="!items().length"
      ></app-button>
    </div>
    <ng-container *ngTemplateOutlet="infoButton"></ng-container>
  </div>
</div>

<!-- Linha (lista) -->
<ng-template #row>
  <div class="row">
    <div class="cell numero">
      <strong>Nº {{ nfce?.numero ?? "—" }}</strong>
      <small>Série {{ nfce?.serie ?? "—" }}</small>
    </div>
    <div class="cell emissao">{{ nfce?.emissao ?? "—" }}</div>
    <div class="cell obra">
      <span [title]="nfce?.clienteNome ?? ''">
        {{ nfce?.numeroObra ? "#" + nfce?.numeroObra + " · " : "" }}
        {{ nfce?.clienteNome || "—" }}
      </span>
      <small *ngIf="nfce?.destinatario; else naoIdentificado">
        {{ nfce?.destinatario ?? "" | formatter: "cpfCnpj" }}
      </small>
    </div>
    <div class="cell valor">
      {{ nfce?.valor | currency: "BRL" : "symbol" : "1.2-2" : "pt-BR" }}
    </div>
    <div class="cell situacao">
      <span class="status" [ngClass]="status.toLowerCase()">
        {{ nfce?.status ?? "—" }}
      </span>
      <small
        class="prazo"
        *ngIf="autorizada && segundosRestantes() !== null"
        [class.encerrado]="!podeCancelar"
      >
        {{ podeCancelar ? "cancelar até " + tempoRestante() : "prazo encerrado" }}
      </small>
      <ng-container *ngIf="rejeitada">
        <ng-container *ngTemplateOutlet="rejeicao"></ng-container>
      </ng-container>
    </div>
    <div class="cell acoes">
      <ng-container *ngTemplateOutlet="infoButton"></ng-container>
      <p-menu
        #menuRow
        [model]="menuOptions()"
        [popup]="true"
        appendTo="body"
        styleClass="nfce-row-menu"
      ></p-menu>
      <button
        type="button"
        class="icon-button"
        aria-label="Opções da NFC-e"
        title="Opções"
        [disabled]="!items().length"
        (click)="menuRow.toggle($event)"
      >
        <i class="pi pi-ellipsis-v"></i>
      </button>
    </div>
  </div>
</ng-template>

<!-- Partes comuns aos dois formatos -->
<ng-template #naoIdentificado>
  <span class="muted">não identificado</span>
</ng-template>

<ng-template #rejeicao>
  <button type="button" class="rejeicao" (click)="showError()">
    <i class="pi pi-exclamation-triangle"></i>
    Ver motivo da rejeição
  </button>
</ng-template>

<ng-template #infoButton>
  <button
    type="button"
    class="icon-button"
    aria-label="Exibir detalhes da nota"
    title="Detalhes"
    (click)="showOverlay($event)"
  >
    <i class="pi pi-info-circle"></i>
  </button>
</ng-template>

<p-overlayPanel #overlay appendTo="body" [style]="{ 'min-width': '200px' }">
  <div class="copy-container">
    <p><strong>ID:</strong> {{ nfce?.id }}</p>
    <p *ngIf="nfce?.chave"><strong>Chave:</strong> {{ nfce?.chave }}</p>
    <p *ngIf="nfce?.protocolo">
      <strong>Protocolo:</strong> {{ nfce?.protocolo }}
    </p>

    <button (click)="copyToClipboard(nfce?.id)">
      <i class="pi pi-copy"></i> Copiar ID
    </button>
  </div>
</p-overlayPanel>
